export default "__VITE_ASSET__B9k5p9dO__"